import { useMemo } from 'react'
import { Flex, Link, LinkExternal, Skeleton, Text, TimerIcon } from '@pancakeswap/uikit'
import styled from 'styled-components'
import BigNumber from 'bignumber.js'
import Balance from 'components/Balance'
// import { getBalanceNumber } from 'utils/formatBalance'
// import { BIG_ZERO } from 'utils/bigNumber'
import BaseCell, { CellContent } from './BaseCell'

interface EndBlocksProps {
    pool: any
}

const StyledCell = styled(BaseCell)`
  flex: 2 0 100px;
  width:200px;
  ${({ theme }) => theme.mediaQueries.md} {
    flex: 1 0 80px;
    /* width:150px; */
  }
`

const PLinkExternal = styled(Link)`
  text-decoration : none;
`

const AprLabelContainer = styled(Flex)`
  &:hover {
    opacity: 0.5;
  }
  
`;

const EndBlocks: React.FC<EndBlocksProps> = ({ pool }) => {
    const { sousId, stakingToken, totalStaked, vaultKey } = pool
    // const { totalCakeInVault } = 'useVaultPoolByKey'(vaultKey)
    // const vaultPools = 'useVaultPools'()
    // const cakeInVaults = Object.values(vaultPools).reduce((total, vault) => {
    //   return total.plus(vault.totalCakeInVault)
    // }, BIG_ZERO)


    return (
        <StyledCell role="cell">
            <CellContent>
                <Text fontSize="12px" color='#00FED9' textAlign="left">
                    Ends in
                </Text>
                <AprLabelContainer height="20px" alignItems="center">
                    <a href={`https://bscscan.com/block/countdown/${pool.bounsEnd.toString()}`} target='_blank' color='#00FED9'>
                        <Balance
                            mt="4px"
                            // display="inline"
                            fontSize='16px'
                            decimals={0}
                            prefix=""
                            value={pool.endsin}
                            // unit={` ${stakingToken.symbol}`}
                            unit={' blocks'}
                            color='white'

                        />
                    </a>
                    {/* <Balance fontSize="16px" value={225} decimals={0} unit={` ${stakingToken.symbol}`} /> */}

                    <TimerIcon ml="4px" color="#00FED9" />
                </AprLabelContainer>

            </CellContent>
        </StyledCell>

        // <StyledCell mb="8px">
        //     <Flex mb="8px" >
        //         <Text>Ends in :</Text>
        //         <Flex>
        //             <Text fontSize="16px" color="rgb(15, 33, 49)" >7,036,348 </Text>
        //             <Text ml="4px" color="rgb(15, 33, 49)" textTransform="lowercase">
        //                 Blocks
        //             </Text>
        //             <TimerIcon ml="4px" color="rgb(15, 33, 49)" />
        //         </Flex>
        //     </Flex>
        // </StyledCell>
    )
}

export default EndBlocks
